<template src="./DynamicTitle.html"></template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { TitleElement } from "./TitleElement";
import AppIcon from "@/components/AppIcon";

export default defineComponent({
    components: { AppIcon },
    emits: ["click"],
    props: {
        elements: { type: Array as PropType<TitleElement[]>, required: true },
        title: { type: String, required: true }
    },
    methods: {
        titleElementClick(name: string | number): void {
            this.$emit("click", name);
        }
    }
});
</script>

<style src="./DynamicTitle.scss" lang="scss" scoped></style>
